import {
  Text,
  View,
  StyleSheet,
  TouchableOpacity,
  Animated,
  ScrollView
} from 'react-native'
import { Ionicons, Entypo, MaterialCommunityIcons } from '@expo/vector-icons'
import * as React from 'react'
// styles
import { globalStyles, fontPalette } from '../../../static/styles/global'
import { useEffect, useState } from 'react'

import moment from 'moment'
import { useLabourStore } from '../../../stores/labour'
import { ActivityIndicator } from 'react-native-paper'
import { useFocusEffect } from '@react-navigation/native'
import { useshiftstore } from '../../../stores/shift'
import { useTranslation } from 'react-i18next'
import { useHomeStore } from '../../../stores/home'
import { convertTo12HourTime } from '../../../utils'

const calculateTotalHours = (data: any[], key: 'workedHours' | 'scheduledHours' | 'scheduleHours'): string => {
  if (!data || data.length === 0) return '';
  let totalSeconds = 0;
  data.forEach((item) => {
    const val = item[key];
    if (val === null || val === undefined) return;
    if (typeof val === 'number') {
      totalSeconds += val * 3600;
    } else {
      const str = String(val).trim();
      if (str.includes(':')) {
        const parts = str.split(':');
        const hh = parseInt(parts[0], 10) || 0;
        const mm = parseInt(parts[1], 10) || 0;
        const ss = parseInt(parts[2], 10) || 0;
        totalSeconds += hh * 3600 + mm * 60 + ss;
      } else {
        const parsed = parseFloat(str);
        if (!isNaN(parsed)) {
          totalSeconds += parsed * 3600;
        }
      }
    }
  });

  if (totalSeconds === 0) return '';
  const hrs = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = Math.round(totalSeconds % 60);

  return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};


const TimelineSkeleton = () => {
  const pulseAnim = React.useRef(new Animated.Value(0.4)).current;

  React.useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(pulseAnim, {
          toValue: 1.0,
          duration: 1000,
          useNativeDriver: true,
        }),
        Animated.timing(pulseAnim, {
          toValue: 0.4,
          duration: 1000,
          useNativeDriver: true,
        }),
      ])
    ).start();
  }, [pulseAnim]);

  return (
    <Animated.View style={{ opacity: pulseAnim, marginTop: 12 }}>
      {/* Header Banner Skeleton */}
      <View style={styles.skeletonBanner} />

      {/* Card Skeleton 1 */}
      <View style={styles.skeletonCard}>
        <View style={styles.skeletonDayHeader} />
        <View style={styles.skeletonShiftCard} />
        <View style={styles.skeletonPunchRow}>
          <View style={styles.skeletonCircle} />
          <View style={styles.skeletonLineShort} />
        </View>
        <View style={styles.skeletonPunchRow}>
          <View style={styles.skeletonCircle} />
          <View style={styles.skeletonLineLong} />
        </View>
      </View>

      {/* Card Skeleton 2 */}
      <View style={styles.skeletonCard}>
        <View style={styles.skeletonDayHeader} />
        <View style={styles.skeletonPunchRow}>
          <View style={styles.skeletonCircle} />
          <View style={styles.skeletonLineShort} />
        </View>
      </View>
    </Animated.View>
  );
};


const Calendar_StripeTwo = ({
  showDays = true,
  headerShow = true,
  shiftLable = 'View Table',
  shiftInfo = false,
  shiftInfoText = '',
  onChangeValue,
  displaydays = true,
  currentPosition = moment().week(),
  customerShifts = []
}): JSX.Element => {
  const [weekNo, setWeekNo] = useState(currentPosition)
  const { t } = useTranslation()
  const homeStore = useHomeStore()



  const onChangeWeek = (startDay: any, endDay: any) => {
    // console.log("startDay", startDay)
    // console.log("endDay", startDay);
    shiftstore.fetchWeekclockins(
      moment(startDay).format('YYYY-MM-DD'),
      moment(endDay).format('YYYY-MM-DD'),
      labourStore?.labourData?.userId
        ? labourStore?.labourData?.userId
        : 0,
      labourStore?.labourData?.entityId,
      homeStore?.homeData?.laborSaverStoreID
    )
  }


  const initialMonthChange = () => {
    return (
      moment().week(weekNo).startOf('week').format('MMM') +
      ' ' +
      moment().week(weekNo).startOf('week').format('DD') +
      ' - ' +
      (moment().week(weekNo).startOf('week').format('MMM') ===
        moment().week(weekNo).endOf('week').format('MMM')
        ? ''
        : moment().week(weekNo).endOf('week').format('MMM')) +
      ' ' +
      moment().week(weekNo).endOf('week').format('DD')
    )
  }
  const initialWeekText = initialMonthChange()
  const [weekText, setWeekText] = useState(initialWeekText)
  const [sunday, setSunday] = useState(
    moment().week(weekNo).startOf('week').format('MMDDYYYY')
  )
  const [saturday, setSaturday] = useState(
    moment().week(weekNo).endOf('week').format('MMDDYYYY')
  )


  const labourStore = useLabourStore()
  const shiftstore = useshiftstore()




  useFocusEffect(
    React.useCallback(() => {
      const fetchData = async () => {
        try {
          const currentWeek = moment().week()
          const startOfWeek = moment().week(weekNo).startOf('week')
          const endOfWeek = moment().week(weekNo).endOf('week')
          const startDay = startOfWeek.format('MMDDYYYY')
          const endDay = endOfWeek.format('MMDDYYYY')
          onChangeWeek(startOfWeek, endOfWeek)
        } catch (error) {
          console.log(error)
        }
      }

      fetchData()
    }, [weekNo])
  )

  useFocusEffect(
    React.useCallback(() => {

      labourStore.setStartWeekDate(moment().startOf('week').format('MM/DD/YYYY'))
      labourStore.setEndWeekDate(moment().endOf('week').format('MM/DD/YYYY'))

      return () => {
        labourStore.setStartWeekDate(moment().startOf('week').format('MM/DD/YYYY'))
        labourStore.setEndWeekDate(moment().endOf('week').format('MM/DD/YYYY'))
        shiftstore.cleartimings()
      }
    }, [])
  )

  useEffect(() => {
    if (labourStore?.startWeekDate && labourStore?.endWeekDate) {
      labourStore.schedulefetchData(
        labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0,
        labourStore.startWeekDate,
        labourStore.endWeekDate
      )
    }
  }, [labourStore.startWeekDate, labourStore.endWeekDate, labourStore?.labourData?.userId])
  const [shiftTitle, setShiftTitle] = React.useState(shiftLable)
  const [clickedDay, setClickedDay] = React.useState('')

  const daysOrder = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  const generateDayModel = (startDay, currentWeek = moment().week()) => {
    const startIndex = daysOrder.indexOf(startDay);
    if (startIndex === -1) return [];

    let startOfWeek = moment().week(currentWeek).day(startIndex);

    if (startOfWeek.week() !== currentWeek) {
      startOfWeek.subtract(7, "days");
    }

    return Array.from({ length: 7 }, (_, i) => {
      const fullDayName = daysOrder[(startIndex + i) % 7];
      const dayShortName = ["thursday", "saturday", "sunday"].includes(fullDayName)
        ? fullDayName.slice(0, 1).toUpperCase() + fullDayName.slice(1, 2).toLowerCase()
        : fullDayName.slice(0, 1).toUpperCase();

      return {
        dayShortName,
        day: startOfWeek.clone().add(i, "days").format("YYYY-MM-DD"),
      };
    });
  };
  const backendStartDay = labourStore?.startdayofweekdata?.payPeriodDay ? labourStore?.startdayofweekdata?.payPeriodDay : 'monday'
  const [currentWeek, setCurrentWeek] = React.useState(moment().week());
  const [weekData, setWeekData] = React.useState(() => generateDayModel(backendStartDay, weekNo));
  const today = moment().format('YYYY-MM-DD')






  const showWeek = (currentWeek, action, backendStartDay) => {
    const weekString = getWeekString(currentWeek, action);

    // Increment / decrement week
    if (action === 'add') {
      currentWeek = currentWeek + 1;
    } else {
      currentWeek = currentWeek - 1;
    }

    // Let moment resolve the correct YEAR for this week
    let baseWeekMoment = moment().week(currentWeek);

    // Backend start day index (Sunday = 0 ... Saturday = 6)
    const startDayIndex = moment().day(backendStartDay).day();

    // Calculate start of week
    let startOfWeek = baseWeekMoment.clone().day(startDayIndex);
    // console.log("start of week", startOfWeek)

    // Fix alignment when backend week does not start on Sunday
    if (startOfWeek.week() !== baseWeekMoment.week()) {
      startOfWeek.subtract(7, 'days');
    }

    const endOfWeek = startOfWeek.clone().add(6, 'days');

    labourStore.setStartWeekDate(startOfWeek.format('MM/DD/YYYY'));
    labourStore.setEndWeekDate(endOfWeek.format('MM/DD/YYYY'));

    const updateDayModel = Array.from({ length: 7 }).map((_, i) => {
      const date = startOfWeek.clone().add(i, 'days');
      const shortName = date.format('dd');
      const isTwoLetterDay = ['Th', 'Sa', 'Su'].includes(shortName);

      return {
        dayShortName: isTwoLetterDay
          ? shortName.charAt(0).toUpperCase() + shortName.charAt(1).toLowerCase()
          : shortName.charAt(0).toUpperCase(),
        day: date.format('YYYY-MM-DD'),
      };
    });

    setWeekData(updateDayModel);
    setWeekText(weekString);
  };

  const getWeekString = (currentWeek, action) => {
    if (action == 'add') {
      currentWeek = currentWeek + 1
    } else {
      currentWeek = currentWeek - 1
    }
    if (currentWeek > moment().week()) {
      // setShiftTitle('Future Shifts')

    } else if (currentWeek < moment().week()) {
      // setShiftTitle('Previous Shifts')
    } else {
      // setShiftTitle('Current Shifts')
    }
    setWeekNo(currentWeek)


    const startOfWeek = moment().week(currentWeek).startOf('week')
    const endOfWeek = moment().week(currentWeek).endOf('week')
    const startDayNumber = startOfWeek.date()
    const endDayNumber = endOfWeek.date()
    const startMonth = startOfWeek.format('MMM')
    const endMonth = endOfWeek.format('MMM')

    let weekText = ''

    if (startMonth === endMonth) {
      weekText = `${startMonth} ${startDayNumber} - ${endDayNumber}`
    } else {
      weekText = `${startMonth} ${startDayNumber} - ${endMonth} ${endDayNumber}`
    }
    let weekType = ''

    if (currentWeek === moment().week()) {
      weekType = 'Current Shifts'
    } else if (currentWeek < moment().week()) {
      weekType = 'Previous Shifts'
    } else {
      weekType = 'Future Shifts'
    }

    // setShiftTitle(weekType)

    setWeekNo(currentWeek)

    setWeekText(weekText)

    onChangeValue(weekText)

    return weekText
  }



  const formatWorkedHours = (hoursStr: string) => {
    if (!hoursStr) return ''
    const parts = hoursStr.split(':')
    if (parts.length >= 2) {
      const hh = parseInt(parts[0], 10)
      const mm = parts[1]
      return `${hh}:${mm} hrs`
    }
    return `${hoursStr} hrs`
  }

  const getPunchLabel = (breakType: string) => {
    const key = `shift_keys.${breakType}`
    const translated = t(key)
    if (translated !== key) {
      return translated
    }
    if (breakType === 'IN') return t('Clock In')
    if (breakType === 'OUT') return t('Clock Out')
    if (breakType === 'BREAK_START') return t('Break Start')
    if (breakType === 'BREAK_END') return t('Break End')
    if (breakType === 'MEAL_START') return t('Meal Break Start')
    if (breakType === 'MEAL_END') return t('Meal Break End')
    return breakType
  }

  return (
    <View>
      {headerShow && (
        <View style={globalStyles.shiftHeader}>
          <Text style={globalStyles.shiftTitle}>{t(shiftTitle)}</Text>
        </View>
      )}
      <View style={styles.weekNavigatorCard}>
        <TouchableOpacity
          onPress={() => {
            showWeek(weekNo, 'previous', backendStartDay)
          }}
          style={styles.navButtonCircle}
          activeOpacity={0.7}
        >
          <Entypo name="chevron-left" size={20} color="#475569" />
        </TouchableOpacity>

        <View style={styles.weekTextContainer}>
          <Text style={styles.weekTextLabel}>{weekText}</Text>
        </View>

        <TouchableOpacity
          onPress={() => {
            showWeek(weekNo, 'add', backendStartDay)
          }}
          style={styles.navButtonCircle}
          activeOpacity={0.7}
        >
          <Entypo name="chevron-right" size={20} color="#475569" />
        </TouchableOpacity>
      </View>

      <View>
        {showDays && weekNo >= moment().week() && (
          <View>
            {shiftInfo && (
              <View>
                <Text style={globalStyles.shiftInfo}>{shiftInfoText}</Text>
              </View>
            )}
          </View>
        )}

      </View>
      {shiftstore?.loading || labourStore?.loading ? (
        <TimelineSkeleton />
      ) : shiftstore?.weekClockinsData?.data && shiftstore?.weekClockinsData?.data?.length > 0 ? (
        <View style={styles.timelineContainer}>
          {/* Summary Metrics Hub */}
          <View style={styles.metricsHubContainer}>
            {/* Worked Hours Metric Card */}
            <View style={styles.metricCard}>
              <View style={styles.metricHeaderRow}>
                <MaterialCommunityIcons name="clock-check-outline" size={15} color="#059669" />
                <Text style={styles.metricLabel}>{t('Worked Hours')}</Text>
              </View>
              <Text style={styles.metricValue}>
                {(() => {
                  const totalWorked = calculateTotalHours(shiftstore?.weekClockinsData?.data || [], 'workedHours');
                  return totalWorked ? `${totalWorked} hrs` : '00:00:00 hrs';
                })()}
              </Text>
            </View>

            {/* Scheduled Hours Metric Card */}
            <View style={[styles.metricCard, { borderLeftColor: '#2563EB' }]}>
              <View style={styles.metricHeaderRow}>
                <MaterialCommunityIcons name="calendar-clock" size={15} color="#2563EB" />
                <Text style={styles.metricLabel}>{t('Scheduled Hours')}</Text>
              </View>
              <Text style={styles.metricValue}>
                {(() => {
                  const totalScheduled = calculateTotalHours(labourStore?.scheduleData?.shiftInfo || [], 'scheduleHours');
                  return totalScheduled ? `${totalScheduled} hrs` : '00:00:00 hrs';
                })()}
              </Text>
            </View>
          </View>

          {/* Daily Schedule / Actuals */}
          {shiftstore?.weekClockinsData?.data
            ?.map((item: any, dayIndex: number) => {
              const sortedPunches = item.data ? [...item.data].sort((a: any, b: any) =>
                moment(a.breakTime).valueOf() - moment(b.breakTime).valueOf()
              ) : [];

              const dayDepartmentNames = sortedPunches.map((p: any) => p.departmentName).filter(Boolean);
              const uniqueDayDepartments = new Set(dayDepartmentNames);
              const hasMultipleDepartments = uniqueDayDepartments.size > 1;

              const dayShifts = labourStore?.scheduleData?.shiftInfo?.filter(
                (shift: any) => shift?.date?.split('T')[0] === moment(item.date).format('YYYY-MM-DD')
              ) || [];
              const sortedDayShifts = [...dayShifts].sort((a: any, b: any) =>
                moment(a.time_In, 'HH:mm').diff(moment(b.time_In, 'HH:mm'))
              );

              const isToday = moment(item.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');

              return (
                <View key={dayIndex.toString()} style={[styles.dayCard,]}>
                  {/* Day Header Row */}
                  <View style={styles.dayHeaderRow}>
                    <View style={[styles.dayHeaderAccent, isToday && { backgroundColor: '#0284C7' }]} />
                    <Text style={[styles.dayLabel, isToday && { color: '#0284C7' }]}>
                      {moment(item.date).format('ddd, MMM DD')}
                    </Text>

                    {sortedPunches[sortedPunches.length - 1]?.breakType === 'OUT' && (
                      <View style={styles.dayHeaderRightWrapper}>
                        <View style={[styles.dayHoursColRight, isToday && { backgroundColor: '#E0F2FE' }]}>
                          <Text style={[styles.dayHours, isToday && { color: '#0369A1' }]}>
                            {formatWorkedHours(item.workedHours)}
                          </Text>
                        </View>
                      </View>
                    )}
                  </View>

                  {/* Scheduled Shifts display as rows */}
                  {sortedDayShifts.map((shift: any, shiftIdx: number) => (
                    <View key={`shift-${shiftIdx}`} style={styles.shiftCard}>
                      <View style={styles.shiftCardHeader}>
                        <Entypo name="calendar" size={13} color="#0369A1" style={{ marginRight: 6 }} />
                        <Text style={styles.shiftCardTitle}>{t('Scheduled Shift')}</Text>
                      </View>

                      <Text style={styles.shiftCardTime}>
                        {convertTo12HourTime(shift.time_In)} - {convertTo12HourTime(shift.time_Out)}
                        {shift.scheduleHours ? ` (${formatWorkedHours(shift.scheduleHours)})` : ''}
                      </Text>

                      {(shift.departmentName || shift.storeName) && (
                        <View style={styles.shiftTagsContainer}>
                          {shift.departmentName && (
                            <View style={styles.shiftTag}>
                              <Text style={styles.shiftTagText}>{shift.departmentName}</Text>
                            </View>
                          )}
                          {shift.storeName && (
                            <View style={[styles.shiftTag, { backgroundColor: '#F0FDF4', borderColor: '#BBF7D0' }]}>
                              <Text style={[styles.shiftTagText, { color: '#15803D' }]}>{shift.storeName}</Text>
                            </View>
                          )}
                        </View>
                      )}
                    </View>
                  ))}

                  {/* Empty Day State */}
                  {sortedDayShifts.length === 0 && sortedPunches.length === 0 && (
                    <View style={styles.emptyDayContainer}>
                      <MaterialCommunityIcons name="calendar-blank-outline" size={14} color="#94A3B8" />
                      <Text style={styles.emptyDayText}>{t('No scheduled shifts or active punches')}</Text>
                    </View>
                  )}


                  {sortedPunches.map((x: any, punchIndex: number) => {
                    const isFirst = punchIndex === 0;
                    const isLast = punchIndex === sortedPunches.length - 1;


                    let iconName = 'clock-outline';
                    let iconColor = '#10B981';
                    let iconBg = '#ECFDF5';
                    let iconBorderColor = '#A7F3D0';

                    if (x.breakType === 'BREAK_START' || x.breakType === 'BREAK_END') {
                      iconName = 'coffee-outline';
                      iconColor = '#0F172A';
                      iconBg = '#F8FAFC';
                      iconBorderColor = '#CBD5E1';
                    } else if (x.breakType === 'MEAL_START' || x.breakType === 'MEAL_END') {
                      iconName = 'silverware-fork-knife';
                      iconColor = '#F59E0B';
                      iconBg = '#FFFBEB';
                      iconBorderColor = '#FDE68A';
                    } else if (x.breakType === 'OUT') {
                      iconName = 'clock-outline';
                      iconColor = '#EF4444';
                      iconBg = '#FEF2F2';
                      iconBorderColor = '#FCA5A5';
                    }

                    return (
                      <View key={punchIndex.toString()} style={styles.punchRow}>
                        {/* Timeline column */}
                        <View style={styles.timelineCol}>
                          <View style={[
                            styles.timelineLine,
                            isFirst && { top: '50%' },
                            isLast && { bottom: '50%' }
                          ]} />
                          <View style={[
                            styles.iconWrapper,
                            {
                              backgroundColor: iconBg,
                              borderColor: iconBorderColor,
                              borderWidth: 1.5,
                              borderRadius: 16,
                              width: 32,
                              height: 32,
                              alignItems: 'center',
                              justifyContent: 'center'
                            }
                          ]}>
                            <MaterialCommunityIcons name={iconName as any} size={15} color={iconColor} />
                          </View>
                        </View>

                        {/* Punch Description and Times */}
                        <View style={styles.punchLabelCol}>
                          <Text style={styles.punchLabel}>
                            {getPunchLabel(x.breakType)}
                            {hasMultipleDepartments && x.departmentName ? ` (${x.departmentName})` : ''}
                          </Text>
                        </View>
                        <View style={styles.punchValueColRight}>
                          <Text style={[styles.punchValue, { color: iconColor }]}>
                            {moment.utc(x.breakTime).format('hh:mm a')}
                          </Text>
                        </View>
                      </View>
                    );
                  })}
                </View>
              );
            })}
        </View>
      ) : (
        <View style={styles.noDataContainer}>
          <MaterialCommunityIcons name="calendar-blank" size={48} color="#94A3B8" />
          <Text style={styles.noDataTitle}>{t('No Data Found')}</Text>
          <Text style={styles.noDataSubtitle}>
            {t('There are no scheduled shifts or active clock-ins recorded for this week.')}
          </Text>
        </View>
      )}

    </View>
  )
}
const styles = StyleSheet.create({
  custom: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    backgroundColor: '#0088CF',
    color: 'black',
    borderWidth: 0,
    width: '90%',
    marginTop: 10
  },
  customCardHeader: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    backgroundColor: '#0088CF',
    borderWidth: 0,
    width: '60%',
    marginTop: -18
  },
  myCard: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    backgroundColor: '#1978cd',
    marginBottom: 20,
    borderRadius: 5
  },
  dangerColor: {
    color: 'red',
    fontSize: 14
  },
  dayClass: {
    justifyContent: 'center',
    paddingLeft: 16,
    paddingRight: 16
  },
  dayActive: {
    width: 6,
    height: 6,
    backgroundColor: 'black',
    borderRadius: 10,
    marginTop: 5
  },
  currentDay: {
    borderWidth: 1,
    borderColor: '#438CD7',
    backgroundColor: '#9FC4E9',
    padding: 8,
    borderRadius: 30
  },
  notCurrentDay: {
    borderWidth: 1,
    borderColor: '#fff',
    backgroundColor: '#fff',
    padding: 8,
    borderRadius: 30
  },
  clickedDay: {
    borderWidth: 1,
    borderColor: '#c3c3c3',
    backgroundColor: '#f1f1f1',
    padding: 8,
    borderRadius: 30
  },
  weekNavigatorCard: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 8,
    marginVertical: 12,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    shadowColor: '#0F172A',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.03,
    shadowRadius: 4,
    elevation: 1
  },
  navButtonCircle: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: '#F1F5F9',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#E2E8F0'
  },
  weekTextContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  },
  weekTextLabel: {
    fontSize: 14,
    fontWeight: '700',
    color: '#0F172A',
    letterSpacing: 0.2
  },
  timelineContainer: {
    marginVertical: 8,
    paddingHorizontal: 4
  },
  metricsHubContainer: {
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    marginBottom: 12
  },
  metricCard: {
    flex: 1,
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 12,
    marginHorizontal: 4,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderLeftWidth: 4,
    borderLeftColor: '#059669',
    shadowColor: '#0F172A',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.02,
    shadowRadius: 3,
    elevation: 1,
    justifyContent: 'space-between'
  },
  metricHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4
  },
  metricLabel: {
    fontSize: 9,
    fontFamily: fontPalette.primaryBold,
    color: '#64748B',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginLeft: 6
  },
  metricValue: {
    fontSize: 13,
    fontFamily: fontPalette.primaryBold,
    color: '#0F172A',
    marginLeft: 21
  },
  dayCard: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: 16,
    marginVertical: 8,
    borderWidth: 1,
    borderColor: '#F1F5F9',
    shadowColor: '#0F172A',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.03,
    shadowRadius: 8,
    elevation: 2
  },
  todayCard: {
    borderColor: '#38BDF8',
    borderLeftWidth: 4,
    shadowColor: '#0284C7',
    shadowOpacity: 0.08,
    shadowRadius: 12
  },
  dayHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
    paddingVertical: 4
  },
  dayHeaderAccent: {
    width: 4,
    height: 16,
    backgroundColor: '#64748B',
    borderRadius: 2,
    marginRight: 8
  },
  dayLabel: {
    flex: 1.5,
    fontSize: 14,
    fontFamily: fontPalette.primaryBold,
    color: '#1E293B',
    flexShrink: 1,
    marginRight: 4
  },
  dayHeaderRightWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: 2,
    flexWrap: 'wrap'
  },

  dayHoursColRight: {
    backgroundColor: '#F1F5F9',
    paddingHorizontal: 8,
    paddingVertical: 3.5,
    borderRadius: 6,
    marginVertical: 2
  },
  dayHours: {
    fontSize: 12,
    fontFamily: fontPalette.primaryBold,
    color: '#475569'
  },
  shiftCard: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingVertical: 12,
    paddingHorizontal: 14,
    marginVertical: 6,
    backgroundColor: '#ffffff',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    borderLeftWidth: 4,
    borderLeftColor: '#2563EB',
    shadowColor: '#0F172A',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.02,
    shadowRadius: 3,
    elevation: 1
  },
  shiftCardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4
  },
  shiftCardTitle: {
    fontSize: 9,
    fontFamily: fontPalette.primaryBold,
    color: '#0369A1',
    textTransform: 'uppercase',
    letterSpacing: 0.5
  },
  shiftCardTime: {
    fontSize: 13,
    fontFamily: fontPalette.primaryBold,
    color: '#0F172A',
    marginLeft: 19,
    marginBottom: 6
  },
  shiftTagsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginLeft: 19,
    marginTop: 4
  },
  shiftTag: {
    backgroundColor: '#EFF6FF',
    borderColor: '#BFDBFE',
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 4,
    marginRight: 6,
    marginVertical: 2
  },
  shiftTagText: {
    fontSize: 9,
    fontFamily: fontPalette.primaryBold,
    color: '#1D4ED8'
  },
  emptyDayContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: '#F8FAFC',
    borderRadius: 8,
    borderStyle: 'dashed',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    marginTop: 6
  },
  emptyDayText: {
    fontSize: 12,
    color: '#64748B',
    fontFamily: fontPalette.primarySemiBold,
    marginLeft: 6
  },
  punchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    marginVertical: 4
  },
  timelineCol: {
    width: 36,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  timelineLine: {
    position: 'absolute',
    left: 17,
    top: 0,
    bottom: 0,
    width: 2,
    backgroundColor: '#F1F5F9'
  },
  iconWrapper: {
    backgroundColor: '#fff',
    paddingVertical: 4
  },
  punchLabelCol: {
    flex: 3,
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 12
  },
  punchLabel: {
    fontSize: 13,
    color: '#334155',
    fontFamily: fontPalette.primarySemiBold
  },
  punchValueColRight: {
    flex: 1.5,
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  punchValue: {
    fontSize: 13,
    color: '#475569',
    fontFamily: fontPalette.primaryBold
  },
  dashedSeparator: {
    borderStyle: 'dashed',
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
    marginVertical: 16
  },
  skeletonBanner: {
    height: 60,
    backgroundColor: '#E2E8F0',
    borderRadius: 16,
    marginBottom: 16,
  },
  skeletonCard: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: 16,
    marginVertical: 8,
    borderWidth: 1,
    borderColor: '#F1F5F9',
  },
  skeletonDayHeader: {
    width: 120,
    height: 16,
    backgroundColor: '#E2E8F0',
    borderRadius: 4,
    marginBottom: 12,
  },
  skeletonShiftCard: {
    height: 36,
    backgroundColor: '#E0F2FE',
    borderRadius: 8,
    marginBottom: 12,
  },
  skeletonPunchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 6,
  },
  skeletonCircle: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#E2E8F0',
    marginRight: 12,
  },
  skeletonLineShort: {
    width: 80,
    height: 12,
    backgroundColor: '#E2E8F0',
    borderRadius: 4,
  },
  skeletonLineLong: {
    width: 140,
    height: 12,
    backgroundColor: '#E2E8F0',
    borderRadius: 4,
  },
  noDataContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 44,
    paddingHorizontal: 24,
    backgroundColor: '#ffffff',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    marginVertical: 12,
    shadowColor: '#0F172A',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.02,
    shadowRadius: 4,
    elevation: 1
  },
  noDataTitle: {
    fontSize: 16,
    fontFamily: fontPalette.primaryBold,
    color: '#1E293B',
    marginTop: 12,
    marginBottom: 4
  },
  noDataSubtitle: {
    fontSize: 13,
    color: '#64748B',
    textAlign: 'center',
    lineHeight: 18
  }
})
export default Calendar_StripeTwo
